import styled from 'styled-components'
import { CSS } from 'ui/helpers'

const WidgetHeader = styled.div<{
  $progress: number
  $hasErrors?: boolean
  $allSuccess?: boolean
  $isFadingOut?: boolean
  $instantReset?: boolean
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 4px 8px;
  overflow: hidden;
  background: ${(p) => p.theme.uiKit.colors.global.general.main};

  cursor: pointer;
  user-select: none;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 120%;
    background: ${(p) => p.theme.uiKit.colors.theme.brand.lightest};
    opacity: ${(p) => (p.$isFadingOut ? 0 : 0.6)};
    border-radius: 0px ${(p) => p.theme.uiKit.borderRadius.roundedFull} ${(p) => p.theme.uiKit.borderRadius.roundedFull}
      0px;
    transform: ${(p) => {
      const progress = p.$progress * 1.2
      const translateX = Math.max(0, 100 - progress)
      return `translateX(-${translateX}%)`
    }};
    transition: ${(p) => (p.$instantReset ? 'none' : 'transform 0.7s ease, opacity 1s ease')};
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1;
  }
`

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
`

const HeaderTitle = styled.div`
  ${(p) => CSS.populateFont(p.theme.uiKit.typography.h5.regular)};
`

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
`

const IconWrapper = styled.div`
  display: flex;
  padding: 8px;
`

export const s = {
  WidgetHeader,
  HeaderLeft,
  HeaderTitle,
  CloseButton,
  IconWrapper
}
